module.exports = __webpack_public_path__ + "static/media/71CVy+LfHEL._AC_UX569_.de828182.jpg";